import styled from 'styled-components';

const Container = styled.div`
  /* Room for the code + name columns of the address blocks. */
  width: min(84rem, 92vw);
`;

export { Container };
